/* @ngInject */
function CampaignPostActionsController ($scope, $rootScope, $timeout, $translate, $window, $state, CampaignActionService, ToastService, ConfirmationModalService, Utils) {
  $scope.flags = {
    advancedOptions: false,
    scheduleDataForAction: false,
    scheduleDeadlineToTakeAction: false,
    buttonLoading: false,
    descriptionError: false,
    hasUnsavedChanges: false,
    disableDateInputs: false
  }

  $scope.chevron = 'chevron-down'

  let defaultDescription

  const api = {
    _successGetActionDetails,
    _setAdvancedOptions,
    _successSaveAction,
    _setDatesAfterAttachPost,
    _archiveAction,
    _unpublishAction
  }

  this.getApi = () => api

  activate()

  function activate () {
    defaultDescription = $translate.instant('campaignPostAction.defaultDescription')
  }

  const deregisterActionIdWatcher = $scope.$watch('action.id', (newId) => {
    const numberRegex = /^\d+$/

    if (numberRegex.test(newId)) {
      CampaignActionService.getCampaignActionDetails($scope.campaign.id, $scope.action.id).then(api._successGetActionDetails)
    } else {
      const action = {
        ...$scope.action,
        campaignId: $scope.campaign.id,
        description: defaultDescription
      }

      $scope.action = action
      $scope.flags.hasUnsavedChanges = true

      api._setDatesAfterAttachPost($scope.action.posts[0] || null)
      api._setAdvancedOptions()
    }
  })

  const deregisterAttachPostActions = $rootScope.$on('campaign.attach-post-actions', (event, selectedPost) => {
    $scope.action.posts = selectedPost ? [selectedPost] : []
    $scope.action.postId = selectedPost?.id || null
    $scope.flags.hasUnsavedChanges = true

    api._setDatesAfterAttachPost(selectedPost)

    if ($scope.action.postId) {
      ToastService.showSuccessToast($translate.instant('campaignEdit.actions.assetAttachedToast'))
    }
  })

  const beforeUnloadHandler = (event) => {
    if ($scope.flags.hasUnsavedChanges) {
      event.preventDefault()
      event.returnValue = $translate.instant('campaignsModule.campaignActionsGeneralDialog.closeWithoutSaving.content')
    }
  }

  $window.addEventListener('beforeunload', beforeUnloadHandler)

  $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
    if ($scope.flags.hasUnsavedChanges && toState.name !== fromState.name) {
      event.preventDefault()

      $scope.handleCancel(true, () => {
        $scope.lastUrl = toState.url
        $state.go(toState, toParams)
      })
    }
  })

  $scope.handleCancel = (shouldShowDialog, onConfirm) => {
    if (!shouldShowDialog) {
      if (typeof onConfirm === 'function') onConfirm()
      return
    }

    ConfirmationModalService.createModal({
      title: $translate.instant('campaignsModule.campaignActionsGeneralDialog.closeWithoutSaving.title'),
      description: $translate.instant('campaignsModule.campaignActionsGeneralDialog.closeWithoutSaving.content'),
      buttonCancelText: $translate.instant('campaignsModule.campaignActionsGeneralDialog.closeWithoutSaving.buttons.close'),
      buttonConfirmText: $translate.instant('campaignsModule.campaignActionsGeneralDialog.closeWithoutSaving.buttons.confirm'),
      onConfirm: () => {
        $scope.flags.hasUnsavedChanges = false
        if (typeof onConfirm === 'function') onConfirm()
      }
    })
  }

  $scope.$on('$destroy', () => {
    deregisterAttachPostActions()
    deregisterActionIdWatcher()
    $window.removeEventListener('beforeunload', beforeUnloadHandler)
  })

  $scope.clickAdvancedOptions = () => {
    $scope.flags.advancedOptions = !$scope.flags.advancedOptions
    $scope.chevron = $scope.flags.advancedOptions ? 'chevron-up' : 'chevron-down'
  }

  $scope.scheduleDataForAction = (event) => {
    $scope.flags.scheduleDataForAction = event.detail.value
    if ($scope.action.publicationDate) {
      $scope.action.publicationDate = undefined
      $scope.flags.hasUnsavedChanges = true
    }
  }

  $scope.scheduleDeadlineToTakeAction = (event) => {
    $scope.flags.scheduleDeadlineToTakeAction = event.detail.value
    if ($scope.action.expirationDate) {
      $scope.action.expirationDate = undefined
      $scope.flags.hasUnsavedChanges = true
    }
  }

  $scope.clickAttachPosts = () => {
    if ($scope.campaign.status === 'LATE') return
    $rootScope.$emit('campaign.change-tab-action', 'tab-5')
    /**
     * Emitido com timeout para dar tempo da tab carregar (caso não tenha sido pré-ativada antes).
     */
    $timeout(() => {
      $rootScope.$emit('campaign.select-post-floating-tool-bar', { post: $scope.action.posts[0], action: $scope.action })
    }, 100)
  }

  $scope.onChangeDescription = (event) => {
    if ($scope.action.description !== event.detail.value) {
      $scope.action.description = event.detail.value
      $scope.flags.hasUnsavedChanges = true
    }
  }

  $scope.onChangeScheduleDate = (event) => {
    $scope.action.publicationDate = event.detail.date
    $scope.flags.hasUnsavedChanges = true
  }

  $scope.onChangeDeadlineDate = (event) => {
    $scope.action.expirationDate = event.detail.date
    $scope.flags.hasUnsavedChanges = true
  }

  $scope.handleArchiveButtonClick = () => {
    ConfirmationModalService.createModal({
      title: $translate.instant('campaignsModule.campaignActionsGeneralDialog.archiveAction.title'),
      description: $translate.instant('campaignsModule.campaignActionsGeneralDialog.archiveAction.content'),
      buttonCancelText: $translate.instant('campaignsModule.campaignActionsGeneralDialog.archiveAction.buttons.close'),
      buttonConfirmText: $translate.instant('campaignsModule.campaignActionsGeneralDialog.archiveAction.buttons.confirm'),
      onConfirm: () => api._archiveAction()
    })
  }

  $scope.handleSaveAction = () => {
    if (!$scope.action.description) {
      $scope.flags.descriptionError = true
      return
    }

    if ($scope.action.posts[0]?.id) {
      $scope.action.postId = $scope.action.posts[0].id
    } else {
      ToastService.showErrorToast($translate.instant('campaignEdit.actions.assetRequired'))
      return
    }

    $scope.flags.buttonLoading = true

    const numberRegex = /^\d+$/
    if (numberRegex.test($scope.action.id)) {
      CampaignActionService.sanitizeAction($scope.action)
      CampaignActionService.updateCampaignAction($scope.campaign.id, $scope.action.id, $scope.action)
        .then(api._successSaveAction)
        .catch(CampaignActionService.handleSaveActionError)
        .finally(() => { $scope.flags.buttonLoading = false })
    } else {
      CampaignActionService.createCampaignAction($scope.campaign.id, $scope.action)
        .then(newAction => api._successSaveAction(newAction, true))
        .catch(CampaignActionService.handleSaveActionError)
        .finally(() => { $scope.flags.buttonLoading = false })
    }
  }

  $scope.getVisibilityLabel = () => {
    return CampaignActionService.getVisibilityLabel($scope.action)
  }

  $scope.handleUnpublishButtonClick = () => {
    ConfirmationModalService.createModal({
      title: $translate.instant('campaignsModule.campaignActionsGeneralDialog.unpublishActions.title'),
      description: $translate.instant('campaignsModule.campaignActionsGeneralDialog.unpublishActions.content'),
      buttonCancelText: $translate.instant('campaignsModule.campaignActionsGeneralDialog.unpublishActions.buttons.close'),
      buttonConfirmText: $translate.instant('campaignsModule.campaignActionsGeneralDialog.unpublishActions.buttons.confirm'),
      onConfirm: () => api._unpublishAction()
    })
  }

  $scope.shouldShowArchiveButton = () => {
    const numberRegex = /^\d+$/
    return numberRegex.test($scope.action.id)
  }

  function _successGetActionDetails (details) {
    $scope.action = details
    $scope.action.publicationStatus = CampaignActionService.getPublicationStatus($scope.action)
    api._setAdvancedOptions()
    api._setDatesAfterAttachPost(details.posts[0])
  }

  function _setAdvancedOptions () {
    $scope.flags.scheduleDataForAction = !!$scope.action.publicationDate
    $scope.flags.scheduleDeadlineToTakeAction = !!$scope.action.expirationDate

    $scope.flags.advancedOptions = $scope.flags.scheduleDataForAction || $scope.flags.scheduleDeadlineToTakeAction
  }

  function _successSaveAction (newAction, isNewAction) {
    $scope.flags.hasUnsavedChanges = false
    ToastService.showSuccessToast($translate.instant('saved'))
    $scope.$emit('campaign.reload-actions', newAction.id)

    if (isNewAction) {
      CampaignActionService.sendCreateCampaignActionEvent($scope.campaign, newAction)
    }
  }

  function _setDatesAfterAttachPost (post) {
    if (post?.scheduleDate && !$scope.action.publicationDate) {
      $scope.flags.advancedOptions = true
      $scope.flags.scheduleDataForAction = true
      $scope.flags.disableDateInputs = true
      $scope.action.publicationDate = moment(post.scheduleDate)
    }

    if (post?.expirationDate && !$scope.action.expirationDate) {
      $scope.flags.advancedOptions = true
      $scope.flags.scheduleDeadlineToTakeAction = true
      $scope.flags.disableDateInputs = true
      $scope.action.expirationDate = moment(post.expirationDate)
    }
  }

  function _archiveAction () {
    CampaignActionService.archiveCampaignAction($scope.campaign.id, $scope.action.id)
      .then(() => {
        $scope.flags.hasUnsavedChanges = false
        ToastService.showSuccessToast($translate.instant('campaignEdit.actions.archiveSuccess'))
        $(`.campaign-actions-list-content .campaign-action-item-${$scope.action.id}`).click()
        $scope.$emit('campaign.reload-actions', $scope.action.id)
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
  }

  function _unpublishAction () {
    $scope.flags.buttonLoading = true
    CampaignActionService.unpublishCampaignAction($scope.campaign.id, $scope.action.id)
      .then(() => {
        ToastService.showSuccessToast($translate.instant('campaignsModule.campaignActionsGeneralDialog.unpublishActions.successMessage'))
        $scope.$emit('campaign.reload-actions', $scope.action.id)
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
      .finally(() => {
        $scope.flags.buttonLoading = false
      })
  }
}

export { CampaignPostActionsController }
